import React from 'react';
import { NextPage } from 'next';
import JoinService from 'components/auth/_join';

const Join: NextPage = () => {
  return <JoinService />;
};

export default Join;
